"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var Loading_1 = require("../common/Loading");
var ShopCarousel_1 = require("./ShopCarousel");
var ShopContext_1 = require("./ShopContext");
var Shop_1 = require("./Shop");
var shop_data_1 = require("../../utils/shopify-graphql/shop-data");
var shopV2_1 = require("../../utils/shopify/shopV2");
var path_1 = require("../../utils/shopify/path");
var ga_1 = require("../../utils/ga");
var ShopContainer = function () {
    var _a;
    var _b = (0, hooks_1.useState)(null), shopData = _b[0], setShopData = _b[1];
    var _c = (0, hooks_1.useState)(0), optionIndex = _c[0], setOptionIndex = _c[1];
    var _d = (0, hooks_1.useState)(0), purchaseTypeIndex = _d[0], setPurchaseTypeIndex = _d[1];
    var _e = (0, hooks_1.useState)(0), quantityIndex = _e[0], setQuantityIndex = _e[1];
    (0, hooks_1.useEffect)(function () {
        var handle = location.pathname.split('/')[2];
        // this will return 'collection', 'product', or 'page' based on url
        var pathType = (0, path_1.getPathType)(location);
        if (!pathType) {
            console.error('this module needs to be loaded within Collection or Page or Product url');
            return;
        }
        (0, shop_data_1.getShopData)(handle, pathType)
            .then(function (data) {
            var _a;
            if (!data) {
                console.error('product data is undefined');
                return;
            }
            var indexes = data.indexes, shopData = data.shopData;
            setShopData(shopData);
            // Set default selections
            setOptionIndex(indexes.optionIndex);
            setPurchaseTypeIndex(indexes.typeIndex);
            setQuantityIndex(indexes.quantityIndex);
            if (
            // set default option to capsule, which is at index 1 instead of 0, if there is a gummy option
            !handle.includes('gummy') &&
                !handle.includes('conception') &&
                shopData.options.references.nodes.length > 1) {
                setOptionIndex(1);
            }
            var isSingleProductBundle = !!((_a = shopData.singleBundleProduct) === null || _a === void 0 ? void 0 : _a.reference);
            if (isSingleProductBundle) {
                setQuantityIndex(2);
            }
        })
            .catch(function (err) { return console.error(err); });
    }, []);
    var handleAddToCart = function () { return __awaiter(void 0, void 0, void 0, function () {
        var productData;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, (0, shopV2_1.getProductData)({
                        shopData: shopData,
                        optionIndex: optionIndex,
                        purchaseTypeIndex: purchaseTypeIndex,
                        quantityIndex: quantityIndex,
                        singleProductBundle: (_a = shopData === null || shopData === void 0 ? void 0 : shopData.singleBundleProduct) === null || _a === void 0 ? void 0 : _a.reference,
                    })];
                case 1:
                    productData = _b.sent();
                    return [4 /*yield*/, (0, shopV2_1.addToCart)(productData.data)];
                case 2:
                    _b.sent();
                    document.dispatchEvent(new Event('fetchAndSlideCart'));
                    if (productData.product && productData.variant) {
                        (0, ga_1.sendAddToCartEventFromShop)(productData.product, productData.variant);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    if (!shopData) {
        return (0, preact_1.h)(Loading_1.default, null);
    }
    return ((0, preact_1.h)(ShopContext_1.default.Provider, { value: {
            colors: JSON.parse(shopData.colors.value),
            handleAddToCart: handleAddToCart,
            singleProductBundle: (_a = shopData.singleBundleProduct) === null || _a === void 0 ? void 0 : _a.reference,
            optionIndex: optionIndex,
            setOptionIndex: setOptionIndex,
            options: shopData.options.references.nodes,
            purchaseTypeIndex: purchaseTypeIndex,
            setPurchaseTypeIndex: setPurchaseTypeIndex,
            quantityIndex: quantityIndex,
            setQuantityIndex: setQuantityIndex,
            shopData: shopData,
            theme: shopData.theme.value,
        } },
        (0, preact_1.h)(ShopCarousel_1.default, null),
        (0, preact_1.h)(Shop_1.default, null)));
};
exports.default = ShopContainer;
